export default {
  storeNamespace: 'reference',
  authFeature: 'reference',
  listRouteName: "OverdueMaintenanceReferenceList",
  detailRouteName: "ReferenceDetail",
  hideActionNewButton: true,
  hideActionEditButton: true,
  hideActionPdfButton: true,
  hideActionDeleteButton: true,
  csvExportFilenamePrefix: 'references en attente d\'étalonnage',
  titleField: 'internal_code',
  sortBy: 'retard',
  sortDesc: true,
  showExtendedFilters: true,
  fields: [{
      name: 'internal_code',
      label: "Code interne",
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
    },
    {
      name: 'product',
      label: "Produit",
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'status',
      label: "Statut",
      inList: true,
      sortable: true,
      tabFilter: true,
      key: 'status_slug',
      inCsvExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inList: true,
      sortable: true,
      extendedFilter: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
    },
    {
      name: 'return_mode',
      label: "Transport",
      type: 'select',
      inForm: false,
      inList: true,
      filterIn: true,
      extendedFilter: true,
      inCsvExport: true,
      inDetail: true,
      formatter: (context, value, item) => item.product.return_mode ? context.$store.getters['product/getReturnMode'](item.product.return_mode).text : null
    },
    {
      name: 'next_espected_maintenance_date',
      label: "Prochaine maintenance",
      type: 'date',
      inList: false,
      sortable: true,
      extendedFilter: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'next_espected_maintenance_date',
      label: "Prochaine maintenance",
      type: 'text',
      inList: true,
    },
    {
      name: 'retard',
      label: "Retard (jours)",
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'agency_number',
      label: "N° d'agence",
      inList: true,
      extendedFilter: true,
      type: 'chosen',
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].agency ? item.reference_logs[0].agency.number : null
    },
    {
      name: 'agency_name',
      label: "Agence",
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].agency ? item.reference_logs[0].agency.name : null
    },
    {
      name: 'business_number',
      label: "N° d'affaire",
      inList: false,
      sortable: true,
      filterIn: true,
      inCsvExport: false,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].business ? item.reference_logs[0].business.number : null
    },
    {
      name: 'business_name',
      label: "Affaire",
      inList: false,
      sortable: true,
      filterIn: true,
      inCsvExport: false,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].business ? item.reference_logs[0].business.number : null
    },
    {
      name: 'filter_retard',
      label: "Urgence",
      inList: false,
      type: 'select',
      extendedFilter: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'asker',
      label: "Demandeur",
      type: 'text',
      inList: true,
      sortable: true,
      extendedFilter: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].asker && item.reference_logs[0].asker.fullname ? item.reference_logs[0].asker.fullname : ''
    },
    {
      name: 'user',
      label: "Utilisateur",
      type: 'text',
      inList: true,
      sortable: true,
      extendedFilter: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].employee && item.reference_logs[0].employee.fullname ? item.reference_logs[0].employee.fullname : ''
    },
    {
      name: 'asker_email',
      label: "Email du demandeur",
      type: 'text',
      inCsvExport: true,
    },
    {
      name: 'last_maintenance_date',
      label: "Dernière maintenance effectuée",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/OverdueMaintenanceReference/config.js